<template>
    <div class="box">
        <div class="top">
            <div class="text">
                <h4>{{title[switchindex]}}</h4>
                <p>{{content[switchindex]}}</p>
            </div>
        </div>
        <div class="notice-wrapper">
                <div class="container lines" id="lines">

                    <ul class="other-ul send">
                    <li>
                        <a href="javascript:void(0)" @click="switchindex=0">
                            <i class="iconfont icon-icon-qqzy1"></i>
                        <p>国际快线</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="switchindex=1">
                        <i class="iconfont icon-icon-ddly"></i>
                        <p>国际专线</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="switchindex=2">
                        <i class="iconfont icon-icon-jgtr"></i>
                        <p>FBA大货</p>
                        </a>
                        </li>
                    </ul>
            </div>
        </div>

        <div class="notice-wrapper overflow">
            <h2 class="ntitle">{{title[switchindex]}}</h2>
            <div class="row">
                <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/yf.jpg">
                <div class="infos">
                    <h2>商品限制</h2>
                    <p v-for="(item,index) in spxz[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/qy.jpg">
                <div class="infos">
                    <h2>服务地域</h2>
                    <p v-for="(item,index) in fwdy[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/fw.jpg">
                <div class="infos">
                    <h2>服务内容</h2>
                    <p v-for="(item,index) in fwnr[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/sx.jpg">
                <div class="infos">
                    <h2>时效</h2>
                    <p v-for="(item,index) in sx[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/zengzhi.jpg">
                <div class="infos">
                    <h2>增值服务</h2>
                    <p v-for="(item,index) in zzfw[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>

            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/gj.jpg">
                <div class="infos">
                    <h2>订单轨迹</h2>
                    <p v-for="(item,index) in ddgj[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
          </div>
        </div>

        <div class="notice-wrapper">
            <h2 class="ntitle">快速咨询发货</h2>

            <div class="wx">
                <div class="wxitem">
                    <p>产品介绍微信</p>
                    <img src="/static/images/wj.png"/>
                </div>
                 <div class="wxitem">
                    <p>产品介绍小红书</p>
                    <img src="/static/images/xiaohoshu.png" alt="广州行运易国际供应链有限公司-小红书" />
                </div>
                <!-- <div class="wxitem">
                    <p>销售咨询微信</p>
                    <img src="/static/images/mq.png"/>
                </div> -->
            </div>
        </div>

    </div>
</template>
<script>
export default {
  name: 'shipping',
  data () {
    return {
      switchindex: 0,
      content: [
        '国际快线是行运易物流整合最优航线资源，全球邮政快递资源推出的线路。全过程实现快收快出，快转运，轨迹透明可视。',
        '国际专线是行运易物流整合优秀航线资源，包机直飞、多口岸固定仓位、稳妥B2C商业清关、末端稳定，由当地邮政及本土快递公司派送推出的线路',
        'FBA是行运易物流整合优秀海运/空运资源的线路。全过程实现快收快出，快转运，轨迹透明可视。'
      ],
      title: ['国际快线', '国际专线', 'FBA大货'],
      spxz: [
        ['是否支持带电:否', '重量限制:30KG', '体积限制:0.23m³', '尺寸限制:各边长≤150cm'],
        ['是否支持带电:是', '重量限制:30KG', '体积限制:0.23m³', '尺寸限制:各边长≤150cm'],
        ['是否支持带电:否', '重量限制:最小21KG']],
      fwdy: [
        ['欧洲：英国、德国', '美洲：美国'],
        ['欧洲：英国、德国、意大利、法国、新西兰', '美洲：美国、加拿大', '澳洲:澳大利亚'],
        ['欧洲：波兰、德国、法国、荷兰、捷克共和国、西班牙、意大利', '美洲：美国、加拿大']
      ],
      fwnr: [
        ['揽件方式：上门揽件 送货到行运易', '干线运输：空运+卡车', '末端派送：派送到家', '清关方式：商业清关'],
        ['揽件方式：上门揽件 送货到行运易', '干线运输：空运+卡车', '末端派送：派送到家', '清关方式：凭证报关、买单报关'],
        ['揽件方式：上门揽件 送货到行运易', '干线运输：空运/海运+卡车', '末端派送：派送到仓库', '清关方式：商业清关']
      ],
      sx: [
        ['英国、美国:5-7天', '其他:7-9天'],
        ['英国、德国、意大利、法国、新西兰:10-12天', '其他:10-20天'],
        ['欧洲空派:6-8天提取', '加拿大空派:8-15个自然日签收', '美国空派:11天', '美国海派:11天']
      ],
      zzfw: [
        ['增值服务:无'],
        ['增值服务:无'],
        ['增值服务:无']
      ],
      ddgj: [
        ['是否可查：是'],
        ['是否可查：是'],
        ['是否可查：是']
      ]
    }
  },
  created () {
    this.switchindex = this.$route.query.id ? this.$route.query.id : 0
  }
}
</script>

<style scoped>

    .wx {
        background:#fff;
        border:1px solid #ebeeee;
        padding: 3px 3px 0 3px;
        background: #fff;
        width: 1300px;
        height:280px;
        box-sizing: border-box;
        text-align: center;
        padding: 40px;
        -webkit-box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
        box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);

    }
     .wxitem img{
        max-width: 200px;
        max-height: 200px;
     }
    .wxitem{
        width:45%;
    margin-right:30px;
    float: left;
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;

    }

*{font-weight: 400;}
body, ul, ol, li, p, h1, h2, h3, h4, h5, h6, form, fieldset, table, td, img, div, dl, dt, dd, input {
    margin: 0;
    padding: 0;
}
.ntitle{
    text-align: center;
    margin-bottom:40px;
    font-size: 42px;
}
.row{
    margin-right: -15px;
    margin-left: -15px;
}
.col-md-6 {
    width: 50%;
    /* margin-right:30px; */
    float: left;
    position: relative;
    min-height: 1px;
    padding-right: 30px;
    padding-left: 15px;
    box-sizing: border-box;
}
 .news-col {
    margin-bottom: 34px;
    position: relative;
    -webkit-box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    padding: 16px 0px 16px 16px;
    background: #fff;
    text-decoration: none;
    color: #666;
    height:170px;
 }
 .news-col .infos p {
    font-size: 13px;
    color: #999;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 2px 0;
    position: relative;
}
 .news-col .infos h2 {
    margin-top:0;
    font-size: 22px;
    color: #333;
    line-height: 22px;
    margin-bottom: 13px;
}
.news-col img {
    width: 260px;
    height: auto;
    overflow: hidden;
}
  .news-col .infos {
    padding: 4px 0 4px 16px;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}
.news-col .infos h2 {
    font-size: 22px;
    color: #333;
    line-height: 22px;
    margin-bottom: 13px;
}
.container {
    background: #fff;
    top: -40px;
    position: relative;
    border-radius: 6px;
    padding: 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    z-index: 9;
}
.overflow {
    overflow: hidden;
}
.notice-wrapper .other-ul li a p {
    font-size: 14px;
    padding-top: 6px;
    margin:0
}
.notice-wrapper {
    position: relative;
    width: 1300px;
    margin:0 auto;
    box-sizing: border-box;
}
.notice-wrapper .other-ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.notice-wrapper .other-ul li {
    width: 25%;
    text-align: center;
    list-style: none;
}
.notice-wrapper .other-ul li a {
    display: inline-block;
    padding: 0 10px;
    text-decoration: none;
    color: #666;
}
.notice-wrapper .other-ul li a i {
    color: #fff;
    font-size: 34px;
    border-radius: 50%;
    height: 50px;
    line-height: 50px;
    display: inline-block;
    width: 50px;
    background: #E7E7E7;
    background: -webkit-gradient(linear, left top, left bottom, from(#005ADC), to(#1C77FA));
    background: linear-gradient(#005ADC, #1C77FA);
    -webkit-box-shadow: 2px 2px 14px rgb(0 90 220 / 30%);
    box-shadow: 2px 2px 14px rgb(0 90 220 / 30%);
}
    .top
    {
        background:url(~@/images/productBg.jpg);background-repeat: no-repeat;background-position-x: center; background-position-y: center;
        width:100%;
        height: 315px;
    }
.text{
    width:1260px;
    padding-top: 45px;
    padding-left:40px;
    margin:0 auto;
}
.text h4{
        color: #333;
    margin-bottom: 12px;
    font-size: 24px;
}
.text p{
    width: 460px;
    color: #333;
        font-size: 14px;
        margin: 10px 0;
    line-height: 22px;
}

    .center{
        width:1300px;
        box-sizing: border-box;
        padding:50px 50px 100px 50px;
        min-height: 800px;
        background-color: #ffffff;
        border-radius: 5px;
        margin:0 auto;
        margin-top:-40px;
    }

    .tag{
        display: inline-block;
        background-color: #004c73;
        border-radius: 100px 35px 35px 100px;
        padding: 8px 18px 8px 35px;
        margin-right: 10px;
        position: relative;
    }

    .tag p
    {
        font-size: 14px;
        color: #fff;
        margin: 0;
        border:none;
    }
    .tag p:before{
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        position: absolute;
        left: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .box{margin-bottom: 50px;;}
</style>



// WEBPACK FOOTER //
// src/components/shipping.vue